module.exports = __webpack_public_path__ + "media/images/top/img_tab_todays_kuji-8d549a0a9932d92c0709bcffe7082224.png";